export default __webpack_public_path__ + "static/media/bi.deeaef8c.png";